/* PATOYS collection: "Load more". Without JavaScript the link goes to the next page and normal pagination works. */
(function () {
  var root = document.querySelector('.pt-collection');
  if (root) root.classList.add('pt-has-loadmore');

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pt-loadmore]');
    if (!btn) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var url = btn.getAttribute('href');
    var wrap = btn.closest('[data-pt-loadmore-wrap]');
    var list = document.querySelector('#product-grid');
    if (!url || !wrap || !list) {
      window.location.href = url;
      return;
    }

    btn.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('bad response');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        if (!items.length) throw new Error('no items');
        items.forEach(function (li) {
          list.appendChild(document.importNode(li, true));
        });
        var nextWrap = doc.querySelector('[data-pt-loadmore-wrap]');
        if (nextWrap) {
          wrap.replaceWith(document.importNode(nextWrap, true));
        } else {
          wrap.remove();
        }
      })
      .catch(function () {
        window.location.href = url;
      });
  });
})();
/* Collection card "Add to cart": same Terms rule as the product page (tick required), then straight to the cart. */
document.addEventListener('click', function (event) {
  var btn = event.target.closest && event.target.closest('[data-pt-card-add]');
  if (!btn) return;
  var wrap = btn.closest('.pt-card-actions');
  var terms = wrap && wrap.querySelector('[data-pt-card-terms]');
  var box = terms && terms.querySelector('input[type="checkbox"]');
  var err = terms && terms.querySelector('.pt-card-terms__error');
  if (box && !box.checked) {
    if (err) err.hidden = false;
    box.focus();
    return;
  }
  if (err) err.hidden = true;
  if (btn.disabled) return;
  btn.disabled = true;
  var label = btn.textContent;
  btn.textContent = btn.getAttribute('data-adding') || label;
  fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      var a = btn.closest('.pt-card-actions').querySelector('a.pt-card-view');
      if (a) window.location.href = a.href;
    });
});
document.addEventListener('change', function (event) {
  var box = event.target;
  if (!box.classList || !box.classList.contains('pt-card-terms__box')) return;
  var err = box.closest('[data-pt-card-terms]').querySelector('.pt-card-terms__error');
  if (box.checked && err) err.hidden = true;
});
